import React, { useContext } from "react";
import PaymentContext from "../../../store/PaymentContext";
import { useRouter } from "next/router";

interface IProps {
    active: boolean,
    color: string,
    currentStep: number
}
const Step1: React.FC<IProps> = ({ active, color, currentStep }) => {
    const router = useRouter();
    const { isMobile } = useContext(PaymentContext)


    let colorActive = '#274FF5';
    let colorUnActive = '#595959'
    return (
        <>
            <div className="text-lg cart_header-text-action" style={{ color: `${active ? colorActive : colorUnActive}` }}>
                Thông tin giỏ hàng
            </div>
            <div
                // onClick={() => {
                //     router.push('/carts')
                // }} 
                className="flex items-center">
                <svg width={isMobile ? 24 : 32} height={isMobile ? 24 : 32} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_i_3960_174663)">
                        <circle cx={22} cy={22} r={22} fill={active ? colorActive : 'white'} />
                    </g>
                    <path opacity="0.4" fillRule="evenodd" clipRule="evenodd" d="M16.9253 29.5733C16.9253 28.8733 17.492 28.3066 18.192 28.3066C18.8836 28.3066 19.4503 28.8733 19.4503 29.5733C19.4503 30.265 18.8836 30.8316 18.192 30.8316C17.492 30.8316 16.9253 30.265 16.9253 29.5733ZM26.3003 29.5733C26.3003 28.8733 26.867 28.3066 27.567 28.3066C28.2586 28.3066 28.8253 28.8733 28.8253 29.5733C28.8253 30.265 28.2586 30.8316 27.567 30.8316C26.867 30.8316 26.3003 30.265 26.3003 29.5733Z" fill={active ? 'white' : colorUnActive} />
                    <path fillRule="evenodd" clipRule="evenodd" d="M28.8255 17.7078C29.3338 17.7078 29.6671 17.8828 30.0005 18.2661C30.3338 18.6494 30.3921 19.1994 30.3171 19.6986L29.5255 25.1653C29.3755 26.2161 28.4755 26.9903 27.4171 26.9903H18.3255C17.2171 26.9903 16.3005 26.1403 16.2088 25.0411L15.4421 15.9569L14.1838 15.7403C13.8505 15.6819 13.6171 15.3569 13.6755 15.0236C13.7338 14.6819 14.0588 14.4569 14.4005 14.5069L16.388 14.8069C16.6713 14.8578 16.8796 15.0903 16.9046 15.3736L17.063 17.2403C17.088 17.5078 17.3046 17.7078 17.5713 17.7078H28.8255ZM23.7755 22.0403H26.0838C26.4338 22.0403 26.7088 21.7569 26.7088 21.4153C26.7088 21.0653 26.4338 20.7903 26.0838 20.7903H23.7755C23.4255 20.7903 23.1505 21.0653 23.1505 21.4153C23.1505 21.7569 23.4255 22.0403 23.7755 22.0403Z" fill={active ? 'white' : colorUnActive} />
                    <defs>
                        <filter id="filter0_i_3960_174663" x={0} y={0} width={44} height={48} filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                            <feFlood floodOpacity={0} result="BackgroundImageFix" />
                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                            <feOffset dy={4} />
                            <feGaussianBlur stdDeviation={2} />
                            <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3960_174663" />
                        </filter>
                    </defs>
                </svg>
                <div className="border-b-2 border-gray-200 w-12 h-1 cart_header-line-step"></div>
            </div>
        </>
    )
}

export default Step1;
